import UILoadingButton from 'UIComponents/button/UILoadingButton';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { getIsPublished } from 'quotes-ui-lib/utils/status';
import useDownloadQuote from 'quotes-ui-lib/hooks/useDownloadQuote';
import { jsx as _jsx } from "react/jsx-runtime";
const DownloadButton = ({
  quote,
  trackingLocation,
  buttonRef,
  onLoadingFinish
}) => {
  const [loading, failed, onClick] = useDownloadQuote(quote, trackingLocation);
  return /*#__PURE__*/_jsx(UITooltip, {
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "quotesUiLib.quoteActions.download.downloadInProgress"
    }),
    disabled: !loading,
    children: /*#__PURE__*/_jsx(UILoadingButton, {
      buttonRef: buttonRef,
      "data-test-id": "download-quote-btn",
      "data-selenium-test": "download-quote-btn",
      use: "tertiary-light",
      responsive: false,
      onClick: onClick,
      loading: loading,
      onLoadingFinish: onLoadingFinish // Called after the loading spinner animation completes
      ,
      failed: failed,
      disabled: loading,
      spinnerProps: {
        'data-test-id': 'download-button-spinner'
      },
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "quotesUiLib.quoteActions.download.buttonText"
      })
    }, "download-button")
  }, "downloadButtonTooltip");
};
export default DownloadButton;
export const showDownloadButton = quote => {
  return getIsPublished(quote);
};